module.exports = __webpack_public_path__ + "static/img/9.514abbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/9.png
// module id = kS/J
// module chunks = 0